import { Controller } from "stimulus"
import { getExperimentCookie, setExperimentCookie, setSingleExperimentCookie } from "../utils/cookies"
import filter from "lodash/filter"
import find from "lodash/find"
import forEach from "lodash/forEach"
import pickBy from "lodash/pickBy"

export default class extends Controller {
  static targets = ["form", "content"]

  initialize() {
    this.allExperimentsData = this.getAllExperiments()
    this.activeExperimentsData = this.getActiveExperiments()
    this.enrolledExperimentsData = this.getEnrolledExperiments()
    this.hydrateFormFields()
  }

  getAllExperiments() {
    return JSON.parse(document.body.dataset.experiments)
  }

  getActiveExperiments() {
    const parsedConfig = this.allExperimentsData

    // Only return experiments that are in a running state
    return pickBy(parsedConfig, (experiment) => experiment.running === true)
  }

  getEnrolledExperiments() {
    const experiments = {}
    const experimentIds = Object.keys(this.activeExperimentsData).map((key) => this.activeExperimentsData[key].id)

    experimentIds.forEach((id) => {
      experiments[id] = this.fetchExperimentCookieValue(id)
    })

    return experiments
  }

  fetchExperimentCookieValue(id) {
    return getExperimentCookie(`market_experiment_${id}`)
  }

  hydrateFormFields() {
    const selectElements = this.formSelectElements()
    const experiments = this.getEnrolledExperiments()

    forEach(experiments, (variant, id) => {
      const selectElement = find(selectElements, (element) => element.name === `experiments[${id}]`)
      if (selectElement) {
        const option = find(selectElement.options, (option) => option.value === variant)

        if (option) {
          option.selected = true
        }
      }
    })
  }

  formSelectElements() {
    return filter(this.formTarget.elements, (element) => element.value !== "" && element.type === "select-one")
  }

  submit(event) {
    event.preventDefault()

    const filteredElements = this.formSelectElements()
    const enrolments = {}

    forEach(filteredElements, (element) => {
      const { value: variant, name } = element
      const regex = /experiments\[(.*)\]/g
      const matches = regex.exec(name)

      if (variant && matches && matches.length > 0) {
        const id = matches[1]

        if (id) {
          const cookieName = `market_experiment_${id}`
          setExperimentCookie(cookieName, variant)
          enrolments[id] = variant
        }
      }
    })

    setSingleExperimentCookie(enrolments)

    window.location.reload()
  }
}
